module.exports = __webpack_public_path__ + "img/56.ea16a700.jpg";